module.exports = __webpack_public_path__ + "img/RemoteAccess.955126c7.png";